export default "production";


// WEBPACK FOOTER //
// ./src/config/env.js